// eslint-disable

import React from "react";
import { Link, graphql } from "gatsby";
import Image from "gatsby-image";

import Bio from "../components/bio";
import Layout from "../components/layout";
import SEO from "../components/seo";
import { CardBox } from "../components/cardbox";
import { MdTimer } from "react-icons/md";
import styles from "./blog.module.scss";

const description = `
This is exactly how it looks when a programmer starts to write something else than a code. The
personal blog of one programmer.
`;

interface BlogIndexProps {
  data: any;
  location: any;
}

const BlogIndex: React.FC<BlogIndexProps> = props => {
  const { data } = props;
  const posts = data.allMarkdownRemark.edges;

  return (
    <Layout>
      <SEO
        title="Main Page"
        description={description}
        keywords={["blog", "javascript", "react", "personal", "calculators"]}
      />
      <CardBox>
        <Bio showWrittenBy={false} />
        {posts.map(({ node }) => {
          if (
            process.env.GATSBY_ENV === "production" &&
            node.frontmatter.publish === false
          ) {
            return null;
          }
          const title = node.frontmatter.title || node.fields.slug;

          return (
            <div
              key={node.fields.slug}
              className={
                styles.post +
                " border mb-16  border-gray-200 overflow-hidden rounded-xl hover:border-white hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-500"
              }
            >
              <Link to={node.fields.slug} style={{ textDecoration: "none" }}>
                {node.frontmatter.cover ? (
                  <div className={styles.coverWrapper}>
                    <Image
                      fluid={node.frontmatter.cover.childImageSharp.fluid}
                      alt="post cover"
                    />
                  </div>
                ) : (
                  <div className="h-10 w-full bg-gradient-to-r from-blue-400 to-green-600" />
                )}
                <div className="p-8">
                  <h2 className="text-2xl mb">{title}</h2>
                  <div className={styles.metaInfo}>
                    <small>{node.frontmatter.date}</small>
                    <div>
                      <MdTimer size={12} />
                      <small>{node.timeToRead}m read</small>
                    </div>
                  </div>
                  {node.frontmatter.description ? (
                    <p>{node.frontmatter.description}</p>
                  ) : (
                    <p dangerouslySetInnerHTML={{ __html: node.excerpt }} />
                  )}
                </div>
              </Link>
            </div>
          );
        })}
      </CardBox>
    </Layout>
  );
};

export default BlogIndex;

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          timeToRead
          excerpt
          fields {
            slug
          }
          frontmatter {
            cover {
              childImageSharp {
                fluid(
                  traceSVG: { color: "#29276c", optCurve: true, threshold: 50 }
                ) {
                  ...GatsbyImageSharpFluid_tracedSVG
                }
              }
            }
            date(formatString: "DD MMMM YYYY")
            title
            publish
          }
        }
      }
    }
  }
`;
